export default "__VITE_ASSET__DS8hgAk8__"